import api from '../../api/client';
// import React from 'react';
// import { Select, Input, InputNumber, DatePicker, Button, Space, Tag, Tooltip, Typography } from 'antd';
// import { DeleteOutlined } from '@ant-design/icons';
// import dayjs from 'dayjs';

// const { Option } = Select;
// const { Text } = Typography;

// const LineRow = ({ item, idx, onChange, onRemove, farms, silos, assetTypes, subtypeMap, onPreviewTag }) => {
//     const cfg = assetTypes.find((t) => t.slug === item.type_slug) || {};
//     const subtypes = subtypeMap[item.type_slug] || [];
//     const qty = cfg.is_batch ? item.quantity || 1 : 1;
//     const total = (qty * (item.cost || 0)).toFixed(2);

//     const updateField = (field, value) => onChange(idx, { ...item, [field]: value });

//     const handleTypeChange = (v) => {
//         const newCfg = assetTypes.find((t) => t.slug === v) || {};
//         onChange(idx, {
//             ...item,
//             type_slug: v,
//             subtype_id: undefined,
//             category: newCfg.is_livestock !== false ? 'livestock' : 'physical',
//             tagNumber: null,
//             batchId: null,
//             gender: null
//         });
//     };

//     return (
//         <tr style={{ borderBottom: '1px solid #f5f5f5', verticalAlign: 'middle' }}>
//             {/* Type */}
//             <td style={{ padding: '5px 4px', minWidth: 120 }}>
//                 <Select
//                     size="small"
//                     value={item.type_slug}
//                     style={{ width: '100%' }}
//                     placeholder="Type"
//                     onChange={handleTypeChange}
//                 >
//                     {assetTypes.map((t) => (
//                         <Option key={t.slug} value={t.slug}>
//                             <Text>{t.name}</Text>
//                         </Option>
//                     ))}
//                 </Select>
//             </td>

//             {/* Subtype */}
//             <td style={{ padding: '5px 4px', minWidth: 110 }}>
//                 <Select
//                     size="small"
//                     value={item.subtype_id}
//                     style={{ width: '100%' }}
//                     placeholder="Subtype"
//                     disabled={!item.type_slug}
//                     onChange={(v) => updateField('subtype_id', v)}
//                     allowClear
//                 >
//                     {subtypes.map((s) => (
//                         <Option key={s.id} value={s.id}>
//                             {s.name}
//                         </Option>
//                     ))}
//                 </Select>
//             </td>

//             {/* Name */}
//             <td style={{ padding: '5px 4px', minWidth: 110 }}>
//                 <Input size="small" value={item.animalName} onChange={(e) => updateField('animalName', e.target.value)} placeholder="Name" />
//             </td>

//             {/* Quantity (batch only) */}
//             <td style={{ padding: '5px 4px', minWidth: 60 }}>
//                 {cfg.is_batch ? (
//                     <InputNumber
//                         size="small"
//                         min={1}
//                         value={item.quantity}
//                         onChange={(v) => updateField('quantity', v)}
//                         style={{ width: '100%' }}
//                     />
//                 ) : (
//                     <Input size="small" value="1" disabled style={{ width: '100%', textAlign: 'center', background: '#fafafa' }} />
//                 )}
//             </td>

//             {/* Unit Cost */}
//             <td style={{ padding: '5px 4px', minWidth: 95 }}>
//                 <InputNumber
//                     size="small"
//                     min={0}
//                     value={item.cost}
//                     onChange={(v) => updateField('cost', v)}
//                     style={{ width: '100%' }}
//                     formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                 />
//             </td>

//             {/* Total */}
//             <td style={{ padding: '5px 4px', minWidth: 95 }}>
//                 <InputNumber
//                     size="small"
//                     disabled
//                     value={total}
//                     style={{ width: '100%', background: '#fafafa' }}
//                     formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                 />
//             </td>

//             {/* Birth date (only livestock) */}
//             {cfg.is_livestock !== false && (
//                 <td style={{ padding: '5px 4px', minWidth: 100 }}>
//                     <DatePicker
//                         size="small"
//                         value={item.birth ? dayjs(item.birth) : null}
//                         onChange={(d) => updateField('birth', d ? d.format('YYYY-MM-DD') : null)}
//                         style={{ width: '100%' }}
//                     />
//                 </td>
//             )}

//             {/* Silo (only livestock with silo) */}
//             {cfg.is_livestock !== false && cfg.has_silo && (
//                 <td style={{ padding: '5px 4px', minWidth: 90 }}>
//                     <Select
//                         size="small"
//                         value={item.siloId}
//                         onChange={(v) => updateField('siloId', v)}
//                         style={{ width: '100%' }}
//                         allowClear
//                     >
//                         {(silos || [])
//                             .filter((s) => !s.type_slug || s.type_slug === item.type_slug)
//                             .map((s) => (
//                                 <Option key={s.id} value={s.id}>
//                                     {s.silo_number}
//                                 </Option>
//                             ))}
//                     </Select>
//                 </td>
//             )}

//             {/* Physical asset fields */}
//             {cfg.is_livestock === false && (
//                 <>
//                     <td style={{ padding: '5px 4px', minWidth: 120 }}>
//                         <Input
//                             size="small"
//                             value={item.assetName}
//                             onChange={(e) => updateField('assetName', e.target.value)}
//                             placeholder="Asset name"
//                         />
//                     </td>
//                     <td style={{ padding: '5px 4px', minWidth: 100 }}>
//                         <Input
//                             size="small"
//                             value={item.serialNumber}
//                             onChange={(e) => updateField('serialNumber', e.target.value)}
//                             placeholder="Serial #"
//                         />
//                     </td>
//                     <td style={{ padding: '5px 4px', minWidth: 75 }}>
//                         <InputNumber
//                             size="small"
//                             min={0}
//                             value={item.usefulLifeYears}
//                             onChange={(v) => updateField('usefulLifeYears', v)}
//                             style={{ width: '100%' }}
//                             placeholder="Life"
//                         />
//                     </td>
//                 </>
//             )}

//             {/* Farm */}
//             <td style={{ padding: '5px 4px', minWidth: 85 }}>
//                 <Select
//                     size="small"
//                     value={item.farm}
//                     onChange={(v) => updateField('farm', v)}
//                     style={{ width: '100%' }}
//                     allowClear
//                 >
//                     {(farms || []).map((f) => (
//                         <Option key={f.id} value={String(f.id)}>
//                             {f.name}
//                         </Option>
//                     ))}
//                 </Select>
//             </td>

//             {/* Delete */}
//             <td style={{ padding: '5px 4px' }}>
//                 <Tooltip title="Remove item">
//                     <Button size="small" danger type="text" icon={<DeleteOutlined />} onClick={() => onRemove(idx)} />
//                 </Tooltip>
//             </td>
//         </tr>
//     );
// };

// export default LineRow;

// components/LineRow.jsx - Updated with dynamic silo selector
import React from 'react';
import { Select, Input, InputNumber, DatePicker, Button, Space, Tag, Tooltip, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import DynamicSiloSelector from '../../components/DynamicSiloSelector';
// import DynamicSiloSelector from './DynamicSiloSelector';

const { Option } = Select;
const { Text } = Typography;

const LineRow = ({ item, idx, onChange, onRemove, farms, silos, assetTypes, subtypeMap, onPreviewTag }) => {
    const cfg = assetTypes.find((t) => t.slug === item.type_slug) || {};
    const subtypes = subtypeMap[item.type_slug] || [];
    const qty = cfg.is_batch ? item.quantity || 1 : 1;
    const total = (qty * (item.cost || 0)).toFixed(2);
    
    const updateField = (field, value) => onChange(idx, { ...item, [field]: value });
    
    const handleTypeChange = (v) => {
        const newCfg = assetTypes.find((t) => t.slug === v) || {};
        onChange(idx, {
            ...item,
            type_slug: v,
            subtype_id: undefined,
            category: newCfg.is_livestock !== false ? 'livestock' : 'physical',
            tagNumber: null,
            batchId: null,
            gender: null,
            siloId: null
        });
    };
    
    // Determine if silo should be shown (livestock with has_silo property)
    const showSilo = cfg.is_livestock !== false && cfg.has_silo;
    
    return (
        <tr style={{ borderBottom: '1px solid #f5f5f5', verticalAlign: 'middle' }}>
            {/* Type */}
            <td style={{ padding: '5px 4px', minWidth: 120 }}>
                <Select
                    size="small"
                    value={item.type_slug}
                    style={{ width: '100%' }}
                    placeholder="Type"
                    onChange={handleTypeChange}
                >
                    {assetTypes.map((t) => (
                        <Option key={t.slug} value={t.slug}>
                            <Text>{t.name}</Text>
                        </Option>
                    ))}
                </Select>
            </td>
            
            {/* Subtype */}
            <td style={{ padding: '5px 4px', minWidth: 110 }}>
                <Select
                    size="small"
                    value={item.subtype_id}
                    style={{ width: '100%' }}
                    placeholder="Subtype"
                    disabled={!item.type_slug}
                    onChange={(v) => updateField('subtype_id', v)}
                    allowClear
                >
                    {subtypes.map((s) => (
                        <Option key={s.id} value={s.id}>
                            {s.name}
                        </Option>
                    ))}
                </Select>
            </td>
            
            {/* Name */}
            <td style={{ padding: '5px 4px', minWidth: 110 }}>
                <Input size="small" value={item.animalName} onChange={(e) => updateField('animalName', e.target.value)} placeholder="Name" />
            </td>
            
            {/* Quantity (batch only) */}
            <td style={{ padding: '5px 4px', minWidth: 60 }}>
                {cfg.is_batch ? (
                    <InputNumber
                        size="small"
                        min={1}
                        value={item.quantity}
                        onChange={(v) => updateField('quantity', v)}
                        style={{ width: '100%' }}
                    />
                ) : (
                    <Input size="small" value="1" disabled style={{ width: '100%', textAlign: 'center', background: '#fafafa' }} />
                )}
            </td>
            
            {/* Unit Cost */}
            <td style={{ padding: '5px 4px', minWidth: 95 }}>
                <InputNumber
                    size="small"
                    min={0}
                    value={item.cost}
                    onChange={(v) => updateField('cost', v)}
                    style={{ width: '100%' }}
                    formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                />
            </td>
            
            {/* Total */}
            <td style={{ padding: '5px 4px', minWidth: 95 }}>
                <InputNumber
                    size="small"
                    disabled
                    value={total}
                    style={{ width: '100%', background: '#fafafa' }}
                    formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                />
            </td>
            
            {/* Birth date (only livestock) */}
            {cfg.is_livestock !== false && (
                <td style={{ padding: '5px 4px', minWidth: 100 }}>
                    <DatePicker
                        size="small"
                        value={item.birth ? dayjs(item.birth) : null}
                        onChange={(d) => updateField('birth', d ? d.format('YYYY-MM-DD') : null)}
                        style={{ width: '100%' }}
                    />
                </td>
            )}
            
            {/* Dynamic Silo Selector (only livestock with has_silo) */}
            {showSilo && (
                <td style={{ padding: '5px 4px', minWidth: 180 }}>
                    <DynamicSiloSelector
                        value={item.siloId}
                        onChange={(siloId) => updateField('siloId', siloId)}
                        typeSlug={item.type_slug}
                        farmId={item.farm}
                        placeholder={`Select ${cfg.name} Silo`}
                        size="small"
                        showAddButton={true}
                    />
                </td>
            )}
            
            {/* Physical asset fields */}
            {cfg.is_livestock === false && (
                <>
                    <td style={{ padding: '5px 4px', minWidth: 120 }}>
                        <Input
                            size="small"
                            value={item.assetName}
                            onChange={(e) => updateField('assetName', e.target.value)}
                            placeholder="Asset name"
                        />
                    </td>
                    <td style={{ padding: '5px 4px', minWidth: 100 }}>
                        <Input
                            size="small"
                            value={item.serialNumber}
                            onChange={(e) => updateField('serialNumber', e.target.value)}
                            placeholder="Serial #"
                        />
                    </td>
                    <td style={{ padding: '5px 4px', minWidth: 75 }}>
                        <InputNumber
                            size="small"
                            min={0}
                            value={item.usefulLifeYears}
                            onChange={(v) => updateField('usefulLifeYears', v)}
                            style={{ width: '100%' }}
                            placeholder="Life"
                        />
                    </td>
                </>
            )}
            
            {/* Farm */}
            <td style={{ padding: '5px 4px', minWidth: 85 }}>
                <Select
                    size="small"
                    value={item.farm}
                    onChange={(v) => updateField('farm', v)}
                    style={{ width: '100%' }}
                    allowClear
                >
                    {(farms || []).map((f) => (
                        <Option key={f.id} value={String(f.id)}>
                            {f.name}
                        </Option>
                    ))}
                </Select>
            </td>
            
            {/* Delete */}
            <td style={{ padding: '5px 4px' }}>
                <Tooltip title="Remove item">
                    <Button size="small" danger type="text" icon={<DeleteOutlined />} onClick={() => onRemove(idx)} />
                </Tooltip>
            </td>
        </tr>
    );
};

export default LineRow;